import React from 'react';
import { Badge } from '../../types';
import BadgeIcon from './BadgeIcon';

interface BadgeCardProps {
  badge: Badge;
  isEarned: boolean;
}

const BadgeCard: React.FC<BadgeCardProps> = ({ badge, isEarned }) => {
  return (
    <div className={`flex items-center p-6 bg-white rounded-lg shadow-md border transition-all duration-300 ${isEarned ? 'border-gray-200' : 'bg-gray-50'}`}>
      <div className={`flex-shrink-0 w-24 h-24 mr-6 ${!isEarned ? 'filter grayscale opacity-50' : ''}`}>
        <BadgeIcon iconName={badge.icon_name} />
      </div>
      <div>
        <h3 className={`text-xl font-bold ${isEarned ? 'text-gray-800' : 'text-gray-500'}`}>{badge.badge_name}</h3>
        <p className={`mt-1 text-gray-600 ${!isEarned ? 'opacity-70' : ''}`}>{badge.description}</p>
        {isEarned && badge.earned_at && (
          <p className="text-xs text-green-600 mt-2 font-semibold">
            Earned on: {new Date(badge.earned_at).toLocaleDateString()}
          </p>
        )}
      </div>
    </div>
  );
};

export default BadgeCard;
